import { render, staticRenderFns } from "./LabelBar.vue?vue&type=template&id=910b5b66&scoped=true"
import script from "./LabelBar.vue?vue&type=script&lang=js"
export * from "./LabelBar.vue?vue&type=script&lang=js"
import style0 from "./LabelBar.vue?vue&type=style&index=0&id=910b5b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910b5b66",
  null
  
)

export default component.exports